var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('loader-bar'),_c('alert-container'),_c('router-view',{staticClass:"app-layout"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }